import { gql } from '@apollo/client';

export const PUBLISH_WORKSPACE_FORM = gql`
  mutation PublishWorkspaceForm($id: ID!) {
    workspaceForm: publishWorkspaceForm(id: $id) {
      id
      published
    }
  }
`;
